import { render } from "./app-tabs.vue?vue&type=template&id=0c15e82b&scoped=true"
import script from "./app-tabs.vue?vue&type=script&lang=js"
export * from "./app-tabs.vue?vue&type=script&lang=js"

import "./app-tabs.vue?vue&type=style&index=0&id=0c15e82b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c15e82b"]])

export default __exports__